import { BaseModel } from '../../_base/crud';
import { Permission } from './permission.model';
import { Expose, Type } from 'class-transformer';
import { User } from './user.model';

export class Role extends BaseModel {
  @Expose()
  id: number;

  @Expose()
  name: string;

  @Expose()
  @Type(() => Permission)
  permissions: Permission[];

  @Expose()
  @Type(() => User)
  users: User[];

  @Expose()
  isCoreRole = false;

  clear(): void {
    this.id = undefined;
    this.name = '';
    this.permissions = [];
    this.isCoreRole = false;
  }
}
